/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface ShipInfoPost200Response
 */
export interface ShipInfoPost200Response {
    /**
     * 
     * @type {Ship}
     * @memberof ShipInfoPost200Response
     */
    ship?: Ship;
}

/**
 * Check if a given object implements the ShipInfoPost200Response interface.
 */
export function instanceOfShipInfoPost200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipInfoPost200ResponseFromJSON(json: any): ShipInfoPost200Response {
    return ShipInfoPost200ResponseFromJSONTyped(json, false);
}

export function ShipInfoPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipInfoPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
    };
}

export function ShipInfoPost200ResponseToJSON(value?: ShipInfoPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ship': ShipToJSON(value.ship),
    };
}

